import Vue from 'vue';
import Vuex from 'vuex';

import { user } from './modules/userStore.js';
import attendStore from './modules/attendStore.js';
import empStore from './modules/empStore.js';
import { report } from './modules/reportStore.js';
import { auth } from './modules/authStore.js';
import { fpScanner } from './modules/fpScannerStore.js';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    user,
    attendStore,
    empStore,
    auth,
    report,
    fpScanner,
  },
  state: {},
  mutations: {},
  actions: {},
});
